import React, { useState } from 'react';
import './Eligibility.css'; // Custom dark theme styles


const Eligibility = () => {
  const [activeTab, setActiveTab] = useState('salaried');

  return (


    
  

    
    
    <div className="container py-5 eligibility-page">
      {/* Hero Section */}
      <section className="eligibility-hero text-center mb-5">
        <h1 className="display-5 fw-bold text-primary mb-3">
          <i className="bi bi-files"></i> Home Loan Documents Requirements
        </h1>
        <p className="lead text-light">Everything you need for a seamless home loan application</p>
      </section>

      {/* Tab Navigation */}
      <ul className="nav nav-pills mb-4 justify-content-center">
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === 'salaried' ? 'active' : ''}`}
            onClick={() => setActiveTab('salaried')}
          >
            <i className="bi bi-briefcase"></i> Salaried
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === 'self' ? 'active' : ''}`}
            onClick={() => setActiveTab('self')}
          >
            <i className="bi bi-person-workspace"></i> Self-Employed
          </button>
        </li>
      </ul>

      {/* Tab Content */}
      <div>
        {activeTab === 'salaried' && <SalariedAccordion />}
        {activeTab === 'self' && <SelfEmployedAccordion />}
      </div>
    </div>
  );
};

const SalariedAccordion = () => (
  <div className="accordion" id="salariedAccordion">
    <AccordionItem
      id="se1"
      title="Proof of Identity"
      items={['Aadhaar Card', 'Driving Licence', 'Voter’s ID Card']}
    />
    <AccordionItem
      id="se2"
      title="Proof of Age"
      items={['Birth Certificate', 'Passport', '10th Marksheet','Bank Account Passbook​​​​','Class 10 Marksheet​​​​','Driving Licence​​​​']}
    />
    <AccordionItem
      id="se3"
      title="Proof of Income"
      items={['3 months payslips', 'Form 16', 'IT Returns (3 years)','Certified letter from employer​​​​','Promotion or increment letter​​​​']}
    />



    <AccordionItem
      id="se4"
      title="Mandotary"
      items={['PAN Card', 'Form 60']}
    />



    <AccordionItem
      id="se5"
      title="Proof of Residence"
      items={['Aadhaar Card', 'Utility Bills like Electricity Bill, Telephone Bill, etc.​​​​ ​​​', 'Passport​​​​','Voter’s ID Card​​​​ ​​​​​​​','Ration Card​​​​ ​​​​​​','Certified letter by recognised public authority​​​​']}
    />



    <AccordionItem
      id="se6"
      title="Other Documents"
      items={['Passport–sized photographs of applicants and co-applicants​​​​ ​​​​ ​​​', 'Proof of self-contribution​​​​​​​​', '​​​Ongoing loan details​​​​','​​Bank statements of the last 6 months showing repayment of loans, if any​​​​​​​​','Cheque for processing fee towards the Home Loan provider​​​​','Employment Contract or Appointment Letter']}
    />



     <AccordionItem
      id="se7"
      title="Property Documents"
      items={['Title Deeds​​​​ ​​​', 'Receipt of payment to developer or seller​​​​', 'Allotment Letter or Buyer’s Agreement​​​​','Certified letter from employer​​​​','​​​Sales Agreement​','Construction estimate details by architect or civil engineer​​​​ ​​​','Plans approved by local authorities​​​​ ​​​','Proof of no encumbrances on property​​​​ ​​​​​']}
    />


    {/* Add more as needed */}
  </div>
);

const SelfEmployedAccordion = () => (
  <div className="accordion" id="selfAccordion">
    <AccordionItem
      id="s1"
      title="Mandatory Documents"
      items={['PAN Card', 'Form 60']}
    />
    <AccordionItem
      id="s2"
      title="Proof of Business Continuity"
      items={['IT Returns (3 yrs)', 'CA Certified Balance Sheet']}
    />
   
   

    <AccordionItem
      id="s3"
      title="Proof of Identity"
      items={['Aadhaar Card', 'Driving Licence','Voter’s ID Card​​​​ ​​​']}
    />



     <AccordionItem
      id="s4"
      title="Proof of Age"
      items={['​​​Birth Certificate​​​​', '​​​Aadhaar Card​​​​ ​​​','Passport​​​​ ​​​','​​Bank Account Passbook​​​​​​​​ ​​​']}
    />




     <AccordionItem
      id="s5"
      title="Proof of Residence"
      items={['Aadhaar Card', 'Utility Bills like Electricity Bill, Telephone Bill, etc.​​​​ ​​​','Voter’s ID Card​​​​ ','Ration Card​​​​ ​​​']}
    />



     <AccordionItem
      id="s6"
      title="Proof of Income"
      items={['Payslip for a minimum of last 3 months', 'IT returns of a minimum last 3 years','Form 16​​​​​​​','Certified letter from employer']}
    />





     <AccordionItem
      id="s7"
      title="Property Document"
      items={['Title Deeds ​​​​​​', 'Receipt of payment to developer or seller​​​​','Allotment Letter or Buyer’s Agreement​​​​​​​​​​​','​​​Sales Agreement​​​​','Construction estimate details by architect or civil engineer​​​​','Plans approved by local authorities​​​​ ','Proof of no encumbrances on property​​​​ ​​​​​']}
    />
    {/* Add more as needed */}
  </div>
);

const AccordionItem = ({ id, title, items }) => (
  <div className="accordion-item bg-dark text-light border-secondary">
    <h2 className="accordion-header" id={`heading-${id}`}>
      <button
        className="accordion-button collapsed bg-dark text-white"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target={`#collapse-${id}`}
        aria-expanded="false"
        aria-controls={`collapse-${id}`}
      >
        <i className="bi bi-chevron-down me-2"></i> {title}
      </button>
    </h2>
    <div
      id={`collapse-${id}`}
      className="accordion-collapse collapse"
      aria-labelledby={`heading-${id}`}
      data-bs-parent={`#${id.includes('se') ? 'selfAccordion' : 'salariedAccordion'}`}
    >
      <div className="accordion-body">
        <ul className="list-group list-group-flush">
          {items.map((item, index) => (
            <li key={index} className="list-group-item bg-dark text-light border-secondary">
              {item}
            </li>
          ))}
        </ul>
      </div>
    </div>
  </div>
);

export default Eligibility;
